import { AuthService } from '../../core/service/authentication/auth.service';
import { NotificationService } from '../../core/service/notifications/notification.service';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../../core/service/loader/loader.service';
import { ApiResponseStatus } from '../../core/models/common/enums/api-response-status.enum';
import ErrorResponse from '../../core/models/common/error-response.model';

@Component({
  selector: 'app-complete-forgot-password',
  templateUrl: './complete-forgot-password.component.html',
  styleUrls: ['./complete-forgot-password.component.scss']
})
export class CompleteForgotPasswordComponent implements OnInit {
  // TEST: http://localhost:4200/reset-password?emailAddress=test@example.com&token=abc123
  regexValidator = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  completePasswordForgotForm: FormGroup = new FormGroup({
    password: new FormControl('', [Validators.required, Validators.pattern(this.regexValidator)]),
    confirmPassword: new FormControl('', [Validators.required, Validators.pattern(this.regexValidator)]),
  }, { validators: [this.passwordMatchValidator()] });

  emailAddress = '';
  token = '';
  isConfirmNewPasswordVisible = false;
  isNewPasswordVisible = false;

  constructor(
    private routeActivatedService: ActivatedRoute,
    private authService: AuthService,
    private notificationService: NotificationService,
    private loaderService: LoaderService,
    private routerService: Router
  ) { }

  ngOnInit() {
    this.routeActivatedService.queryParams.subscribe(params => {
      this.emailAddress = decodeURIComponent(params['emailAddress']);
      this.token = decodeURIComponent(params['token']);

      if (!this.emailAddress || !this.token) {
        this.notificationService.showError('Invalid reset link');
        this.routerService.navigate(['']);
      }
    });
  }

  checkPasswords(group: FormGroup) {
    const pass = group.get('password')?.value;
    const confirmPass = group.get('confirmPassword')?.value;
    return pass === confirmPass ? null : { notSame: true };
  }

  onSubmit() {
    if (this.completePasswordForgotForm.invalid) return;

    const { password } = this.completePasswordForgotForm.value;

    this.authService.completeRestorePassword(this.emailAddress, this.token, password).subscribe(
      (response) => {
        this.loaderService.hideLoader();
        if (response && response.status === ApiResponseStatus.Error) {
          const errorResponse = response.content as ErrorResponse;
          console.error(errorResponse);
          this.notificationService.showError('Operation failed');
        } else {
          this.notificationService.showSuccess('Password successfully changed');
          this.completePasswordForgotForm.reset();
          this.routerService.navigate(['']);
        }
      });
  }

  toggleConfirmNewPasswordVisibility(): void {
    this.isConfirmNewPasswordVisible = !this.isConfirmNewPasswordVisible;
  }

  toggleNewPasswordVisibility(): void {
    this.isNewPasswordVisible = !this.isNewPasswordVisible;
  }

  /*===== VALIDATORS ========*/

  passwordMatchValidator(): ValidatorFn {
    return (form: AbstractControl): ValidationErrors | null => {
      const password = form.value.password;
      const confirmPassword = form.value.confirmPassword;

      if (password && confirmPassword && password !== confirmPassword) {
        return { passwordMismatch: true };
      }
      return null;
    };
  }

}
